import React, { cloneElement, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { GenericButtonProps } from '../interfaces';
import I18nWrapper from './i18n-wrapper';

const GenericButton = ({
  active,
  testid,
  label,
  appendElement,
  prependElement,
  ...rest
}: GenericButtonProps) => {
  const [isActive, setIsActive] = useState<boolean>(false);
  const { t } = useTranslation();

  useEffect(() => {
    setIsActive(active || false);
  }, [active]);

  return (
    <Button
      size="sm"
      active={isActive}
      aria-label={t(label)}
      data-testid={testid}
      {...rest}
    >
      {prependElement && <>{cloneElement(prependElement)}</>}
      <I18nWrapper translateKey={label} />
      {appendElement && <>{cloneElement(appendElement)}</>}
    </Button>
  );
};

export default GenericButton;
